export enum BrowserTargetType {
  BLANK = "_blank",
  SELF = "_self",
}
